import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import LogCapture from "../../utils/LogManagement/LogHelper";
import { OktaAuth } from "@okta/okta-auth-js";
import { oktaConfig } from "../../config/okta.config";

export default function LoginCustomCallback() {
    const { oktaAuth, authState } = useOktaAuth();
    useEffect(() => {
        const { clientId, scopes } = oktaConfig.oktaAuth;
        var authClient = new OktaAuth(oktaConfig.oktaAuth);
        authClient.session.get().then(() => {
            authClient.token
                .getWithoutPrompt({
                    clientId,
                    scopes,
                })
                .then((data) => {
                    let tokens = data.tokens;
                    oktaAuth.handleLoginRedirect(tokens);
                    const email =
                        tokens?.accessToken?.claims?.email || "unknown";
                    LogCapture.info(`${email} logged in to the portal`);
                })
                .catch((err) => {
                    console.log("err", err);
                });
        });
    });

    if (!authState) return null;
    return authState.isAuthenticated ? (
        <Redirect to="/admin/dashboard" />
    ) : (
        <div></div>
    );
}
